<template>
  <div id="main" >
    <div class="infomain1">
        <div class="prenuminfo1">
            前方<span class="numx">{{wxbaseinfo.prenum}}</span>位等候者
        </div>
        <div class="infodetail1">
            <mt-field label="当前排队科室"  v-model="wxbaseinfo.departmnet" readonly></mt-field>
            <mt-field label="您的号码" v-model="wxbaseinfo.serial" readonly></mt-field>
            <mt-field label="预计就诊时间" v-model="wxbaseinfo.visittime" readonly></mt-field>
        </div>
    </div>
  </div>  
</template>

<script>
import Axios from 'axios'
import qs from 'qs';

export default {
  name: 'main',
  data () {
    return {
      msg: '这里是提交预约页面',        
      wxbaseinfo:{
        name:'',
        departmnet:'',
        serial:'',
        prenum:'',
        visittime:''
      }
    }
  },
  created(){       
        // 显示排队信息
        this.wxbaseinfo.name=this.$route.params.name;
        this.wxbaseinfo.departmnet=this.$route.params.departmnet;
        this.wxbaseinfo.serial=this.$route.params.serial;
        this.wxbaseinfo.prenum=this.$route.params.prenum;
        this.wxbaseinfo.visittime=this.$route.params.visittime;
  }
}
</script>

<style>
#main,/*设置占满*/
html,
body {
  background-color: #f4f4f4;
  width: 100%;
  height: 100%;
  margin: 0;
}
.numx{
    width: 64px;
    height: 64px;
    padding:0px 8px;
    border-radius:50%;
    background-color: royalblue;
    font-size: 64px;
    color:white;
    text-align: center;
}
.infomain1{
  width: 75%;
  height: 200px;
  background-color:white;
  font-family: Arial; 
  border: 1px solid #f4f4f4; 
  border-radius: 20px; 
  padding: 30px 30px; 
  margin: 5%;
}
.infodetail1{
    top: 50px;
}
.prenuminfo1{
    height: 64px;
    font-size: 26px;
}
</style>


// WEBPACK FOOTER //
// src/components/Dispqueuinfo.vue